var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScheduleNewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1959_124215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 1.16675L5.83325 3.16675M11.1666 1.16675V3.16675M11.8333 5.83342H5.16659M8.23325 15.1667H8.76658C11.0068 15.1667 12.1269 15.1667 12.9825 14.7308C13.7352 14.3473 14.3471 13.7354 14.7306 12.9827C15.1666 12.1271 15.1666 11.007 15.1666 8.76675V8.23342C15.1666 5.9932 15.1666 4.8731 14.7306 4.01745C14.3471 3.2648 13.7352 2.65288 12.9825 2.26939C12.1269 1.83341 11.0068 1.83341 8.76659 1.83341H8.23325C5.99304 1.83341 4.87294 1.83341 4.01729 2.26939C3.26464 2.65288 2.65272 3.2648 2.26923 4.01745C1.83325 4.8731 1.83325 5.9932 1.83325 8.23341V8.76675C1.83325 11.007 1.83325 12.1271 2.26923 12.9827C2.65272 13.7354 3.26464 14.3473 4.01729 14.7308C4.87294 15.1667 5.99304 15.1667 8.23325 15.1667Z",
    stroke: "#8C8F9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1959_124215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleNewIcon);
export default __webpack_public_path__ + "static/media/Schedule_new_icon.f70768b9.svg";
export { ForwardRef as ReactComponent };